import {APP_INITIALIZER, ApplicationConfig} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from "@angular/common/http";
import {AuthInterceptor} from "./auth/auth.interceptor";
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {DatePipe, DecimalPipe} from "@angular/common";
import {ModelCatalogService} from "./models/model-catalog.service";
import {AuthService} from "./auth/auth-service";

function initializeModelCatalog(modelCatalogService: ModelCatalogService): () => Promise<void> {
  return () => modelCatalogService.loadModels();
}

function initializeAuth(authService: AuthService): () => Promise<void> {
  return () => authService.refreshToken();
}

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    DecimalPipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()), {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }, provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeModelCatalog,
      deps: [ModelCatalogService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    }
  ]
};
